import { render } from "./Workplace.vue?vue&type=template&id=903f4a96"
import script from "./Workplace.vue?vue&type=script&lang=js"
export * from "./Workplace.vue?vue&type=script&lang=js"

import "./Workplace.vue?vue&type=style&index=0&id=903f4a96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__